/* eslint-disable react/jsx-no-bind */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import styled from 'styled-components';

import { baseUrl } from 'shared/constants';

const SignInStyled = styled(Button)`
	height: 32px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		min-width: 70px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		min-width: 70px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		min-width: 70px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		min-width: 70px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		min-width: 100px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		min-width: 100px;
	}
`;

export const SignIn: FC = () => {
	const handleLogin = (): void => {
		sessionStorage.setItem(`user-page`, window.location.pathname);
	};

	const { t } = useTranslation();

	return (
		<a href={`${baseUrl}/privateapi/auth/externallogin?provider=mpoidc&returnUrl=${window.location.href}`}>
			<SignInStyled onClick={handleLogin}>{t(`Marketplace_Sign_In`)}</SignInStyled>
		</a>
	);
};
